
import { z } from "zod";

export const ProjectCategoryValues = ["ASSESSMENT", "BACKFILL", "BID", "CORRECTIONS", "ESTIMATE_ONLY", "FULL_ROOF", "GUTTERS", "MISC", "PARTIAL_ROOF", "QA", "REINSTALL", "REMOVAL", "RFR", "SIDING", "SITE_VISIT", "SOLAR_REDESIGN", "STRUCTURAL", "VENT_WORK"] as const;
export const ProjectCategorySchema = z.enum(ProjectCategoryValues);
export const ProjectCategory = ProjectCategorySchema.enum;
export type ProjectCategory = (typeof ProjectCategoryValues)[number];
export const ProjectCategoryDisplayNames = { "ASSESSMENT": "Assessment",
"BACKFILL": "Backfill",
"BID": "Bid",
"CORRECTIONS": "Corrections",
"ESTIMATE_ONLY": "Estimate only",
"FULL_ROOF": "Full roof",
"GUTTERS": "Gutters",
"MISC": "Miscellaneous",
"PARTIAL_ROOF": "Partial roof",
"QA": "QA",
"REINSTALL": "Reinstall",
"REMOVAL": "Removal",
"RFR": "RFR",
"SIDING": "Siding",
"SITE_VISIT": "Site visit",
"SOLAR_REDESIGN": "Solar redesign",
"STRUCTURAL": "Structural",
"VENT_WORK": "Vent work", } satisfies Record<ProjectCategory, string>;
